
const headers = [
    {
      label: 'ผู้ขอคำปรึกษา / วันที่ขอคำปรึกษา / เจ้าหน้าที่ผู้ดำเนินการ',
      field: 'fullname',
    },
    {
      label: 'ผู้ถูกร้อง',
      field: 'company',
    },
    {
      label: 'ประเภทให้คำปรึกษา/แนะนำด้านร้องทุกข์',
      field: 'type',
      thClass: 'text-center',
    },
    {
      label: 'เรื่องให้คำปรึกษา/แนะนำช่องทาง',
      field: 'subject',   
      thClass: 'text-center',
    },
    {
      label: 'วันที่รับเรื่อง/จัดการ',
      field: 'action',
      tdClass: 'text-center',
    },
  ]

  export default headers